import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { NotificationSeverity } from './notification-severity.enum'

/**
 * Shared notification icon component for displaying severity-based icons
 */
@Component({
  selector: 'vdr-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationIconComponent {
  @Input() severity: NotificationSeverity = NotificationSeverity.INFO
  @Input() size: 'sm' | 'md' | 'lg' = 'md'

  NotificationSeverity = NotificationSeverity

  /**
   * Get icon URL for notification severity
   */
  getNotificationIcon(severity: NotificationSeverity): string {
    switch (severity) {
      case NotificationSeverity.SUCCESS:
        return 'assets/icons/icn-alert-success.svg'
      case NotificationSeverity.DANGER:
        return 'assets/icons/icn-alert-danger.svg'
      case NotificationSeverity.WARNING:
        return 'assets/icons/icn-alert-warning.svg'
      case NotificationSeverity.INFO:
        return 'assets/icons/icn-folder-plus.svg' // Use folder-plus for reconciliation
      default:
        return 'assets/icons/icn-alert-success.svg'
    }
  }

  /**
   * Get size classes based on size input
   */
  getSizeClasses(): string {
    switch (this.size) {
      case 'sm':
        return 'w-4 h-4'
      case 'md':
        return 'w-6 h-6'
      case 'lg':
        return 'w-8 h-8'
      default:
        return 'w-6 h-6'
    }
  }
} 